import { Typography } from "@mui/material";
import { TESTING_TYPES_DATA } from "constants/global";

interface ExaminationTypeTitleProps {
  examinationTypeData: (typeof TESTING_TYPES_DATA)[number] | undefined;
}

const ExaminationTypeTitle = ({ examinationTypeData }: ExaminationTypeTitleProps) => {
  return (
    <Typography
      variant='colored'
      sx={{ backgroundColor: examinationTypeData?.color, paddingY: 0.8 }}>
      {examinationTypeData?.title || ""}
    </Typography>
  );
};

export default ExaminationTypeTitle;
